import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../../auth/auth.service';
import { PermissionService } from '../service/permission.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private readonly router: Router,
    private readonly authService: AuthService,
    private readonly permissionService: PermissionService
  ) { }

  canActivate(): boolean {
    // AUTHENTICATION DISABLED: Always allow access to protected routes
    // return true;


    const token = this.authService.getToken();
    const userData = this.authService.getUserData();

    // Check if token and userData exist
    if (token && userData) {
      // User is authenticated, load permissions if not already loaded
      const allPerms = this.permissionService.getAllPermissions();
      if (allPerms.length === 0 && !this.permissionService.getLoadingState()) {
        this.permissionService.fetchPermissions();
      }
      
      // Allow access
      return true;
    } else {
      // No token or user data, redirect to login page
      this.router.navigate(['/auth/signin']);
      return false;
    }
  }
}
